module.exports = __webpack_public_path__ + "static/media/soundtrue.1de6c75d.mp3";